export default "__VITE_ASSET__CQ72IqqY__"